import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCgGqQqoaEopcUAtZTkPxu5ZqK_9r4m1BI",
  authDomain: "ecommerce-7b0d5.firebaseapp.com",
  projectId: "ecommerce-7b0d5",
  storageBucket: "ecommerce-7b0d5.appspot.com",
  messagingSenderId: "618944315467",
  appId: "1:618944315467:web:2bf701780ddb2901588dce",
  measurementId: "G-35M769KZGF",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
